import { cn } from '@/utils'

export const OperationLabelPlaceholder = ({ className }) => (
  <div
    style={{ width: 154, borderColor: 'rgba(129, 140, 248, 0.5)' }}
    className={cn('border-4 rounded-md p-0 text-xs', className)}
  >
    <div style={{ padding: 5, height: 25 }} className="text-gray-400">
      Write something...
    </div>
  </div>
)
